/**
 * Created by olga on 13.12.2024
 */

YatzyTutorialHelper = {};

YatzyTutorialHelper.createStep = function (data) {
    if (data.roll !== undefined) {
        return YatzyTutorialHelper.createRollStep(data);
    }
    if (data.dice !== undefined) {
        return YatzyTutorialHelper.createDiceStep(data);
    }

    if (data.slot !== undefined) {
        return YatzyTutorialHelper.createSlotStep(data);
    }
};

YatzyTutorialHelper.createRollStep = function (data) {
    const scene = cleverapps.Scenes.GetSceneComponent(YatzySceneComponent);
    const force = data.force;

    const options = {
        onStart: function () {
            const highlights = data.highlights || YatzyTutorialHelper.getHighlights();
            const importantNodes = data.importantNodes || YatzyTutorialHelper.getImportantNodes();

            Game.currentGame.setSuggestedRoll(data.roll);

            force.finger = false;
            force.pointer = true;
            force.persistent = true;
            this.force = cleverapps.forces.create(scene.rollButton, force, {
                highlights,
                importantNodes
            });
            cleverapps.tutorial.on("roll", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
        }
    };

    return new TutorialStep(options);
};

YatzyTutorialHelper.createSlotStep = function (data) {
    const scene = cleverapps.Scenes.GetSceneComponent(YatzySceneComponent);
    const force = data.force;

    const options = {
        onStart: function () {
            const highlights = data.highlights || YatzyTutorialHelper.getHighlights();
            const importantNodes = data.importantNodes || YatzyTutorialHelper.getImportantNodes();

            if (Game.currentGame.hintSlots) {
                Game.currentGame.hintSlots.push(data.slot);
            }

            const yatzyPlayed = Game.currentGame.slots[Slot.YATZY].used;
            const score = Game.currentGame.slots[data.slot].calcScore(yatzyPlayed);
            Game.currentGame.slots[data.slot].setScore(score);
            scene.yatzyField.slots[data.slot].hintScore();
            scene.yatzyField.slots[data.slot].wiggleOn();
            cleverapps.tooltipManager.remove(scene.yatzyField.slots[data.slot].icon);
            Game.currentGame.highlightCombo();

            force.finger = false;
            force.pointer = true;
            force.persistent = true;
            this.force = cleverapps.forces.create(scene.yatzyField.slots[data.slot], force, {
                finger: false,
                highlights,
                importantNodes
            });

            cleverapps.tutorial.on("slot", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            scene.yatzyField.slots[data.slot].wiggleOff();
        }
    };

    return new TutorialStep(options);
};

YatzyTutorialHelper.createDiceStep = function (data) {
    const force = data.force;
    const dice = cleverapps.aims.getTarget(`dice${data.dice}`);

    const options = {
        onStart: function () {
            const highlights = data.highlights || YatzyTutorialHelper.getHighlights();
            const importantNodes = data.importantNodes || YatzyTutorialHelper.getImportantNodes();
            dice.wiggleOn();

            force.finger = false;
            force.pointer = true;
            force.persistent = true;
            this.force = cleverapps.forces.create(dice, force, {
                finger: false,
                highlights,
                importantNodes
            });

            cleverapps.tutorial.on("dice", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            dice.wiggleOff();
        }
    };

    return new TutorialStep(options);
};

YatzyTutorialHelper.getHighlights = function () {
    const scene = cleverapps.Scenes.GetSceneComponent(YatzySceneComponent);
    return [scene.dicesView, scene.yatzyField, scene.rollButton, cleverapps.Scenes.GetMovingNode()];
};

YatzyTutorialHelper.getImportantNodes = function () {
    const scene = cleverapps.Scenes.GetSceneComponent(YatzySceneComponent);
    return [scene.dicesView, scene.yatzyField, scene.rollButton];
};

YatzyTutorialHelper.find3DicesWithSameScore = function (allowGreater) {
    const yatzy = Game.currentGame;
    const diceCount = yatzy.getDiceCount();
    let score;
    diceCount.forEach((element, index) => {
        if (element === 3 || allowGreater && element > 3) {
            score = index;
        }
    });

    if (score) {
        const dicesWithSameScore = yatzy.dices.filter((dice) => dice.score === score);
        if (dicesWithSameScore.length) {
            return dicesWithSameScore;
        }
    }
};

YatzyTutorialHelper.hasTwoPairs = function () {
    const diceCount = Game.currentGame.getDiceCount();
    return diceCount.filter((count) => count === 2).length === 2;
};
